var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('top-container',{attrs:{"image":_vm.headerImage,"pageTitle":_vm.pageTitle,"isHomepage":_vm.homepage}}),_c('col-3',{attrs:{"title":"","content":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }